import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loadDetails: [],
};

const appointmentSlice = createSlice({
  name: "appointment",
  initialState,
  reducers: {
    setLoadDetails: (state, action) => {
      state.loadDetails = action.payload;
    },
  },
});

export const { setLoadDetails } = appointmentSlice.actions;
export default appointmentSlice.reducer;
